class IFrameWrapperController {
    constructor($browser) {
        this.$onInit = () => {
            this.iframeSrc = location.origin + this.browser.baseHref() + this.src;
            this.htmlElem = angular.element(document).find('html');
            this.htmlVal = this.htmlElem.css('overflow-y'); // store current value so as to reset in component onDestroy
            this.htmlElem.css('overflow-y', 'hidden');
        };
        this.$onDestroy = () => {
            this.htmlElem.css('overflow-y', this.htmlVal);
        };
        this.browser = $browser;
    }
}
angular.module('app').component('iframeWrapper', {
    bindings: {
        src: '<',
        modal: '<'
    },
    templateUrl: 'scripts/app/components/iframe-wrapper/iframe-wrapper.tpl.html',
    controllerAs: 'vm',
    controller: IFrameWrapperController
});
